module.exports = __webpack_public_path__ + "img/RapidappsParallax.28fea89e.jpeg";